import type {CallIntent} from '@phonehq/rtc-core';
import logger from '../../../services/logger';
import {groupCallService} from '../services/groupCallService';
import type {CallBlockOrigin} from '../services/groupCallOrchestrator';

export const runCallControl = async (control: string, action: () => Promise<unknown>): Promise<void> => {
    try {
        await action();
    } catch (error) {
        logger.warn('Group call control failed', {
            source: 'group_call',
            event: 'control_failed',
            control,
            errorName: error instanceof Error ? error.name : undefined,
            error: error instanceof Error ? error.message : String(error),
        });
    }
};

export const openRoomCallLobby = (roomId: string, intent: CallIntent, origin: CallBlockOrigin = 'surface'): void =>
    void runCallControl('open_lobby', () => groupCallService.openLobby(roomId, intent, origin));
